/**
 * Runtime polyfills for older WebViews.
 *
 * MUST be imported before any other module (it is the first import in
 * `main.tsx`) so the globals exist before module-level code runs — e.g.
 * `src/types/communicationPreferences.ts` calls `structuredClone` while
 * building its default-preference constants at import time.
 *
 * `structuredClone` ships in Chrome/WebView 98+. Some Android System WebView
 * versions in the wild (and Google Play's pre-launch test devices) are older
 * and throw `ReferenceError: structuredClone is not defined`, which crashes the
 * whole app at load. All objects we clone are plain JSON-serializable config
 * (notification-channel and permission settings — no Date/Map/Set/undefined),
 * so a JSON round-trip is a correct fallback for our use. Native is preferred
 * whenever it exists, so modern browsers are unaffected.
 *
 * Installe aussi un stockage en mémoire quand le navigateur interdit
 * localStorage / sessionStorage (voir `storageFallback.ts`).
 */
import { installStorageFallback } from "./storageFallback";

if (typeof globalThis.structuredClone !== "function") {
  globalThis.structuredClone = (<T>(value: T): T =>
    value === undefined ? value : JSON.parse(JSON.stringify(value))) as typeof structuredClone;
}

if (typeof window !== "undefined") {
  installStorageFallback(window);
}
